import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
}

const SITE_NAME = '91影视';
const BASE_URL = 'https://www.91yingshi.com';
const DEFAULT_DESCRIPTION =
  '91影视提供海量高清电影、电视剧、综艺、动漫在线免费观看，资源丰富、更新及时、无需注册即可畅享。';
const DEFAULT_KEYWORDS =
  '91影视,91影视在线观看,91影视免费电影,91影视高清电视剧,91影视最新资源,91影视官网入口,91影视手机版';

export default function SEOHead({
  title,
  description = DEFAULT_DESCRIPTION,
  keywords = DEFAULT_KEYWORDS,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  schema,
}: SEOHeadProps) {
  const location = useLocation();
  const pageUrl = canonicalUrl || `${BASE_URL}${location.pathname}`;
  const pageTitle = title ? `${title} - ${SITE_NAME}` : `${SITE_NAME} - 海量高清影视资源免费在线观看`;

  useEffect(() => {
    document.title = pageTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', pageUrl);
    }

    setMeta('og:title', pageTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', pageUrl, true);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
    }

    setMeta('twitter:title', pageTitle);
    setMeta('twitter:description', description);

    if (schema) {
      const scriptId = 'schema-jsonld';
      let scriptEl = document.getElementById(scriptId) as HTMLScriptElement | null;
      if (!scriptEl) {
        scriptEl = document.createElement('script');
        scriptEl.id = scriptId;
        scriptEl.type = 'application/ld+json';
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(schema);
    }

    return () => {
      const scriptEl = document.getElementById('schema-jsonld');
      if (scriptEl && schema) {
        scriptEl.textContent = '';
      }
    };
  }, [pageTitle, description, keywords, pageUrl, ogType, ogImage, schema]);

  return null;
}